import {
  DEFAULT_ACTIVE_COLORS,
  DEFAULT_COLORS_BG,
  DEFAULT_COLORS_FONT,
  DEFAULT_FONT
} from '@opengov/stories-shared/constants';

import { gql } from '../../utils/helper';

function ensureColorSetting(
  colorTarget: 'background' | 'font',
  contentType: 'body_content' | 'header' | 'footer',
  defaultActive: string,
  defaultSwatches: string[]
): string {
  return `
    insert_entityStoryColorSettings_one(
      object: {
        colorTarget: ${colorTarget},
        contentType: ${contentType},
        entityId: $entityId,
        active: "${defaultActive}",
        swatches: ${JSON.stringify(defaultSwatches)}
      },
      on_conflict: {
        constraint: entityStoryColorSettings_pkey,
        update_columns: [contentType, entityId, colorTarget]
      }
    ) {
      active
      swatches
    }
  `;
}

export const ensureSettings = `
  mutation createOrGetSettings($entityId: Int!) {
    entitySettings: insert_entityStorySettings_one(
      object: {
        entityId: $entityId
        logoFooter: ""
        logoHeader: ""
        logoPlacementHeaderAsFooter: false
        logoPlacementHeaderOnly: false
        logoPlacementUniqueFooter: false
        logoPlacementFooterOnly: false
        fontsHeadline: "${DEFAULT_FONT.id}"
        fontsParagraph: "${DEFAULT_FONT.id}"
        googleAnalyticsId: ""
      }
      on_conflict: { constraint: entityStorySettings_entityId_key, update_columns: entityId }
    ) {
      logoHeader
      logoFooter
      fontsParagraph
      fontsHeadline
      logoPlacementFooterOnly
      logoPlacementHeaderOnly
      logoPlacementUniqueFooter
      logoPlacementHeaderAsFooter
      googleAnalyticsId
      entityId
    }
    bodyBackground: ${ensureColorSetting(
      'background',
      'body_content',
      DEFAULT_ACTIVE_COLORS.body.background,
      DEFAULT_COLORS_BG
    )}
    bodyFont: ${ensureColorSetting('font', 'body_content', DEFAULT_ACTIVE_COLORS.body.font, DEFAULT_COLORS_FONT)}
    headerBackground: ${ensureColorSetting(
      'background',
      'header',
      DEFAULT_ACTIVE_COLORS.header.background,
      DEFAULT_COLORS_BG
    )}
    headerFont: ${ensureColorSetting('font', 'header', DEFAULT_ACTIVE_COLORS.header.font, DEFAULT_COLORS_FONT)}
    footerBackground: ${ensureColorSetting(
      'background',
      'footer',
      DEFAULT_ACTIVE_COLORS.footer.background,
      DEFAULT_COLORS_BG
    )}
    footerFont: ${ensureColorSetting('font', 'footer', DEFAULT_ACTIVE_COLORS.footer.font, DEFAULT_COLORS_FONT)}
  }
`;

export const updateSettings = gql`
  mutation updateSettings(
    $entityId: Int!
    $newSettings: entityStorySettings_set_input!,
    $bodyBackground: entityStoryColorSettings_set_input!,
    $bodyFont: entityStoryColorSettings_set_input!,
    $headerBackground: entityStoryColorSettings_set_input!,
    $headerFont: entityStoryColorSettings_set_input!,
    $footerBackground: entityStoryColorSettings_set_input!,
    $footerFont: entityStoryColorSettings_set_input!
    ) {
    entitySettings: update_entityStorySettings_by_pk(pk_columns: {entityId: $entityId}, _set: $newSettings) {
      logoHeader
      logoFooter
      fontsParagraph
      fontsHeadline
      logoPlacementFooterOnly
      logoPlacementHeaderOnly
      logoPlacementUniqueFooter
      logoPlacementHeaderAsFooter
      googleAnalyticsId
      entityId
    }
    bodyBackground: update_entityStoryColorSettings_by_pk(
      pk_columns: {colorTarget: background, contentType: body_content, entityId: $entityId},
      _set: $bodyBackground
    ){
      active
      swatches
    }
    headerBackground: update_entityStoryColorSettings_by_pk(
      pk_columns: {colorTarget: background, contentType: header, entityId: $entityId},
      _set: $headerBackground
    ){
      active
      swatches
    }
    footerBackground: update_entityStoryColorSettings_by_pk(
      pk_columns: {colorTarget: background, contentType: footer, entityId: $entityId},
      _set: $footerBackground
    ){
      active
      swatches
    }
    bodyFont: update_entityStoryColorSettings_by_pk(
      pk_columns: {colorTarget: font, contentType: body_content, entityId: $entityId},
      _set: $bodyFont
    ){
      active
      swatches
    }
    headerFont: update_entityStoryColorSettings_by_pk(
      pk_columns: {colorTarget: font, contentType: header, entityId: $entityId},
      _set: $headerFont
    ){
      active
      swatches
    }
    footerFont: update_entityStoryColorSettings_by_pk(
      pk_columns: {colorTarget: font, contentType: footer, entityId: $entityId},
      _set: $footerFont
    ){
      active
      swatches
    }
  }
`;
